export default __webpack_public_path__ + "static/media/093-up-arrow-6.c23a31c4.png";